import Api from '.';
import { endpoints } from './endpoints';

export default class PreLoginApi extends Api {
    getGeneralBanners(data) {
        let url = this.buildUrl(endpoints.preLogin.getGeneralBanners, "full")
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    aboutUs(data) {
        let url = this.buildUrl(endpoints.preLogin.aboutUs, "full")
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    InterBusiness(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.internationalBusiness, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getAIFDetails(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.getAIFDetails, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getFaq(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.faq, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    NavCall(data) {
        // console.log("In generateOtp", data)


        let url = this.buildUrl(endpoints.preLogin.NavDetail, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    NavHistoricalfilter(data) {
        // console.log("In generateOtp", data)


        let url = this.buildUrl(endpoints.preLogin.HistoricalFilter, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    MFhome(data) {
        // console.log("In generateOtp", data)


        let url = this.buildUrl(endpoints.preLogin.MFHome, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    Category(data) {
        // console.log("In generateOtp", data)


        let url = this.buildUrl(endpoints.preLogin.FundCategory, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    CategoryNew(data) {
        // console.log("In generateOtp", data)


        let url = this.buildUrl(endpoints.preLogin.FundCategoryNew, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    getMFfilter(data) {

        let url = this.buildUrl(endpoints.preLogin.GetFundsForFilter, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    fundDetail(data) {
        // console.log("In generateOtp", data)


        let url = this.buildUrl(endpoints.preLogin.fundDetail, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    InactivefundDetail(data) {
        let url = this.buildUrl(endpoints.preLogin.InactivefundDetail, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    CompareFunds(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.CompareFunds, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    passiveHome(data) {
        // console.log("In generateOtp", data)

        let url = this.buildUrl(endpoints.preLogin.passiveHome, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    download(data) {

        let url = this.buildUrl(endpoints.preLogin.download, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    SearchDownloads(data) {
        let url = this.buildUrl(endpoints.preLogin.SearchDownloads, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    ContactUs(data) {
        let url = this.buildUrl(endpoints.preLogin.ContactUs, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    enquiry(data) {
        let url = this.buildUrl(endpoints.preLogin.enquiry, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    perforamceGraph(data) {
        let url = this.buildUrl(endpoints.preLogin.perforamceGraph, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    perforamceGraphNew(data) {
        let url = this.buildUrl(endpoints.preLogin.perforamceGraphNew, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    STPCategory(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.STPCategory, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    PMSCategory(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.PMSCategory, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    PMSGraphData(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.PMSGraphData, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    PMSFundDetail(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.PMSFundDetail, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getAllFunds(data) {
      let url = this.buildUrl(endpoints.preLogin.getAllFunds, "full");
      return this.fetchNormal(url, "POST", JSON.stringify(data)).then(
        (response) => response
      );
    }
    getFundsCategorisation(data) {
      let url = this.buildUrl(endpoints.preLogin.getFundsCategorisation, "full");
      return this.fetchNormal(url, "POST", JSON.stringify(data)).then(
        (response) => response
      );
    }
    getSchemesForSEO(data) {
        // console.log("In generateOtp", data)
        let payloadData = {
            "api_name": "getSchemesForSEO"
        }
        let url = this.buildUrl(endpoints.preLogin.getSchemesForSEO, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(payloadData)).then(response => response);
    }
    getInactiveSchemesForSEO(data) {
        let payloadData = {
            "api_name": "getSchemesForSEO"
        }
        let url = this.buildUrl(endpoints.preLogin.getInactiveSchemesForSEO, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(payloadData)).then(response => response);
    }
    getTotalExpratio(data) {
        let payloadData = {
            "api_name": "TotalExpratio"
        }
        let url = this.buildUrl(endpoints.preLogin.getTotalExpratio, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(payloadData)).then(response => response);
    }
    WPposts(data) {
        let payloadData = {
            "apiName": "WPposts"
        }
        let url = this.buildUrl(endpoints.preLogin.WPposts, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(payloadData)).then(response => response);
    }
    WPPostMedia(data) {
        let payloadData = {
            "apiName": "WPPostMedia"
        }
        let url = this.buildUrl(endpoints.preLogin.WPPostMedia, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(payloadData)).then(response => response);
    }

}
